import React from "react";
import "./ErrorFallback.scss";

interface ErrorFallbackProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  icon?: string;
  logo?: string;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({
  title = "Page temporarily unavailable",
  message = "This page is currently undergoing maintenance. Please check back shortly.",
  onRetry,
  icon = "/Icons/Group 13.svg",
  logo = "/images/DpLogo.png",
}) => {
  return (
    <div className="error-fallback">
      <div className="error-fallback-card">
        <div className="error-fallback-brand">
          <div className="logo-row">
            <img src={icon} alt="Popup Icon" className="popup-icon" />
            <img src={logo} alt="Announcement Logo" className="popup-logo" />
          </div>
        </div>

        <h2 className="error-fallback-title">{title}</h2>
        <p className="error-fallback-message">{message}</p>

        <div className="error-fallback-illustration" aria-hidden="true">
          <img src="/Icons/bro.svg" alt="Maintenance illustration" className="Error-image"/>
        </div>
      </div>
    </div>
  );
};

export default ErrorFallback;
